


<input #fileInput type="file" (change)="fileChangeEvent($event, modalEl)" />

<!-- <p-fileUpload name="myfile[]" mode="basic" [customUpload]="true" (uploadHandler)="fileChangeEvent($event, modalEl)"></p-fileUpload> -->

<ng-template #modalEl>

  <app-modal-header
    (close)="close()">
    <span slot="title">
      {{ 'admin.image-load-crop-modal.title' | translate }}
    </span>
  </app-modal-header>

  <div class="modal-body">
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="maintainAspectRatio"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="aspectRatio"
      [resizeToWidth]="512"
      [onlyScaleDown]="false"
      [roundCropper]="false"
      [alignImage]="'center'"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady($event)"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>

  <div class="modal-footer">

    <button (click)="onDone()" pButton [label]="'admin.image-load-crop-modal.submit-btn.label' | translate"></button>
    <button (click)="close()" pButton [label]="'admin.image-load-crop-modal.cancel-btn.label' | translate"></button>

  </div>

</ng-template>
